import { Application } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'
import { registerControllers } from 'stimulus-vite-helpers'
import { Alert } from 'tailwindcss-stimulus-components'

const application = Application.start()
application.register('alert', Alert)

// Load shared application controllers
const sharedControllers = import.meta.glob('~/application_controllers/**/*_controller.js', { eager: true })

// Load v2-specific controllers
const v2Controllers = import.meta.glob('~/v2_controllers/**/*_controller.js', { eager: true })

window.Stimulus = application
registerControllers(application, sharedControllers)
registerControllers(application, v2Controllers)

Turbo.setProgressBarDelay(500)

document.addEventListener('turbo:load', function () {
  window.CLUTCHCO && window.CLUTCHCO.Init()
})

// Theme toggle - apply saved preference before paint to avoid flash
;(function() {
  const stored = localStorage.getItem('theme')
  if (stored === 'light') document.documentElement.setAttribute('data-theme', 'light')
})()

document.addEventListener('turbo:load', function() {
  const btns = document.querySelectorAll('#theme-toggle, #theme-toggle-mobile')
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const isLight = document.documentElement.getAttribute('data-theme') === 'light'
      if (isLight) {
        document.documentElement.removeAttribute('data-theme')
        localStorage.setItem('theme', 'dark')
      } else {
        document.documentElement.setAttribute('data-theme', 'light')
        localStorage.setItem('theme', 'light')
      }
    })
  })
})
